import { Button } from '@uhg-abyss/web/ui/Button';
import { Text } from '@uhg-abyss/web/ui/Text';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { PortalContext } from '../../context/PortalContext';
import { useConfig } from '../../frontends/ProviderSearch/context/Analytics';
import { getLanguage } from '../../frontends/ProviderSearch/context/Internationalization/helpers';
import { adobeLinkTrackEvent } from '../AdobeTagging/adobeLinkTrackEvent';
import { LinkWithTracking } from '../LinkWithTracking/LinkWithTracking';
import { isLawwMember } from '../Utils/memberUtils/memberUtils';
import {
  AdditionalFeedbackContainer,
  AdditionalFeedbackInstruction,
} from './index.style';

export const ReportAdditionalFeedback = () => {
  const { t } = useTranslation();
  const locale = getLanguage().code;
  const { portalData } = useContext(PortalContext);

  const additionalReportingEnglishLink = useConfig(
    'FEEDBACK_FORM_ADDITIONAL_REPORTING_DEFAULT'
  );
  const additionalReportingSpanishLink = useConfig(
    'FEEDBACK_FORM_ADDITIONAL_REPORTING_SPANISH'
  );
  const email = useConfig('FEEDBACK_FORM_SUPPORT_EMAIL');
  const externalReportingLink =
    locale === 'es'
      ? additionalReportingSpanishLink
      : additionalReportingEnglishLink;

  const handleExternalLinkClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const newWindow = window.open(externalReportingLink, '_blank');

    // Fallback: reload the full URL after a short delay
    setTimeout(() => {
      if (newWindow) {
        newWindow.location.href = externalReportingLink;
      }
    }, 5000);
  };
  return (
    <React.Fragment>
      <AdditionalFeedbackContainer>
        <AdditionalFeedbackInstruction>
          <Text
            css={{
              display: 'block',
              paddingBottom: '4px',
              lineHeight: '22.4px',
            }}
            data-auto-testid="feedback-report-options-heading"
            data-testid="feedback-report-options-heading"
            fontSize="md"
            fontWeight="medium"
          >
            {t('FEEDBACK_FORM.REPORT_OPTIONS')}
          </Text>
          <Text
            css={{ display: 'block', lineHeight: '22.4px' }}
            data-auto-testid="feedback-report-by-phone-or-email-text"
            data-testid="feedback-report-by-phone-or-email-text"
            fontWeight="regular"
          >
            {isLawwMember(portalData?.portalName)
              ? t('FEEDBACK_FORM.REPORT_BY_PHONE_OR_EMAIL_LAWW')
              : t('FEEDBACK_FORM.REPORT_BY_PHONE_OR_EMAIL')}
          </Text>
          <Button
            css={{
              lineHeight: '18px',
              fontWeight: '400',
              padding: 0,
              height: 'none',
            }}
            data-auto-testid="email-address"
            data-testid="email-address"
            href={`mailto:${email}`}
            onClick={() =>
              adobeLinkTrackEvent({
                name: 'email send feedback',
                location: 'body:details header',
                type: 'email',
                destinationUrl: `mailto:${email}`,
              })
            }
            variant="text"
          >
            {email}
          </Button>
        </AdditionalFeedbackInstruction>
        <LinkWithTracking
          data-auto-testid="additional-reporting-page-link-text"
          data-testid="additional-reporting-page-link-text"
          onClick={handleExternalLinkClick}
          openNewWindow={true}
        >
          <Text color="$core.color.brand.60" fontSize="lg" fontWeight="medium">
            {t('FEEDBACK_FORM.ADDITIONAL_REPORTING_RESOURCES')}
          </Text>
        </LinkWithTracking>
      </AdditionalFeedbackContainer>
    </React.Fragment>
  );
};
